<div *ngIf="isDev" class="env-badge">
    <span class="env-badge-full">Ambiente de Desarrollo</span>
    <span class="env-badge-short">DEV</span>
</div>
<div class="min-h-screen flex items-center justify-center">
    <div class="max-w-[414px] w-full">
        <div class="px-6 py-8 bg-blue-secondary shadow-dm rounded-sm mb-7">
            <div class="flex items-center justify-center mb-6">
                <img src="../../../assets/img/sige.png" alt="SIGE" class="h-[22px] w-auto mr-2">
                <span class="text-white text-2xl font-semibold">SIGE</span>
            </div>
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
                    <mat-label class="text-gray text-lg">Correo Electrónico</mat-label>
                    <input matInput type="email" formControlName="email" class="text-lg text-white bg-blue-primary" required>
                    <mat-error *ngIf="emailControl?.invalid && (emailControl?.dirty || emailControl?.touched)">
                        <span *ngIf="emailControl?.errors?.['required']">El correo electrónico es requerido.</span>
                        <span *ngIf="emailControl?.errors?.['email']">Ingrese un formato de correo electrónico válido.</span>
                    </mat-error>
                </mat-form-field>
                <mat-form-field floatLabel="always" class="w-full mb-4">
                    <mat-label class="text-gray text-lg">Contraseña</mat-label>
                    <div class="relative">
                        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" required>
                        <button matIconButton (click)="togglePasswordVisibility()" type="button" class="password-toggle right-0">
                            <mat-icon class="text-orange">{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                    </div>
                    <mat-error *ngIf="passwordControl?.invalid && (passwordControl?.dirty || passwordControl?.touched)">
                        <span *ngIf="passwordControl?.errors?.['required']" class="block">La contraseña es requerida</span>
                        <span *ngIf="passwordControl?.errors?.['minLength']" class="block">La contraseña debe tener al menos {{ passwordControl?.errors?.['minLength']?.requiredLength }} caracteres.</span>
                        <span *ngIf="passwordControl?.errors?.['hasLowercase']" class="block">La contraseña debe contener al menos una letra minúscula.</span>
                        <span *ngIf="passwordControl?.errors?.['hasUppercase']" class="block">La contraseña debe contener al menos una letra mayúscula.</span>
                        <span *ngIf="passwordControl?.errors?.['hasNumeric']" class="block">La contraseña debe contener al menos un número.</span>
                        <span *ngIf="passwordControl?.errors?.['hasSpecial']" class="block">La contraseña debe contener al menos un caracter especial.</span>
                    </mat-error>
                </mat-form-field>
                <div class="mb-4">
                    <mat-checkbox formControlName="rememberMe">Recuérdame</mat-checkbox>
                </div>
                <div>
                    <button matButton type="submit" class="w-full">Iniciar Sesión</button>
                </div>
            </form>
        </div>
        <div class="flex justify-center">
            <a [routerLink]="['/password-reset']" class="text-white text-sm">¿Has olvidado tu contraseña?</a>
        </div>
    </div>
</div>
